import { loginRequest } from "../../user/services/auth.services";
import { getInvitationsList } from "../../services/acc.services";
import { IS_SHARED_ACCOUNT_SELECTED } from "./teamActions";
import { GET_ALL_INVITATIONS } from "./userActions";

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const DEVICE_TOKEN = "DEVICE_TOKEN";
export const SELECT_SHARED_ACCOUNT_USER = "SELECT_SHARED_ACCOUNT_USER";

// authActions.js
export const loginUserAction = (data, history, setLoading, setError) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const result = await loginRequest(data);

      if (!result || !result.data) {
        setError("Invalid email or password");
        return;
      }

      // Persist the user immediately (so other actions can read it)
      dispatch({
        type: LOGIN_USER_SUCCESS,
        payload: result.data,
      });

      // Check accepted invitations
      const response = await getInvitationsList(
        result.data.token,
        result.data.email,
        "accepted"
      );

      console.log("[loginUserAction] invitations response:", response?.data);

      if (response?.data?.length > 0) {
        // Save invitations in redux
        dispatch({ type: GET_ALL_INVITATIONS, payload: response.data });

        // Optional: keep the flag for other logic
        dispatch({ type: IS_SHARED_ACCOUNT_SELECTED });

        // DIRECTLY navigate to selectaccount (reliable)
        history.push("/selectaccount");
        return; // stop further navigation
      }

      // Normal flow (no accepted invites)
      if (result.data?.isAdmin) {
        history.push("/home");
      } else {
        history.push("/selectteam");
      }
    } catch (e) {
      console.error("Error during login:", e);
      if (e.response?.status === 401 || e.response?.status === 403) {
        setError("Invalid email or password");
      } else {
        setError("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };
};



